import { useFormContext, Controller } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
import Edit from '@mui/icons-material/Edit';
import CustomTooltip from '@/components/CustomTooltip';

interface DiscountStringFieldProps {
  name: string;
  onEditClick: () => void;
  index: number;
  label?: string;
}

export const DiscountStringField = ({
  name,
  onEditClick,
  label = 'Add Discount'
}: DiscountStringFieldProps) => {
  const { control, getValues } = useFormContext();
  const value = getValues(name);
  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState: { error } }) => (
        <Box>
          <Button
            variant="outlined"
            onClick={onEditClick}
            size="small"
            sx={{
              height: 38,
              width: '100%',
              minWidth: 300,
              maxWidth: 400,
              textTransform: 'none',
              justifyContent: 'space-between',
              borderColor: error ? 'error.main' : 'grey.300',
              '&:hover': {
                borderColor: error ? 'error.main' : 'primary.main'
              }
            }}
          >
            {value ? (
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                width="100%"
                justifyContent="space-between"
              >
                <CustomTooltip
                  fullText={value}
                  text={value}
                  previewLength={30}
                />
                
                <Edit
                  fontSize="small"
                  sx={{
                    color: "action.active",
                    opacity: 0.5,
                    "&:hover": { opacity: 1 }
                  }}
                />
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                {label}
              </Typography>
            )}
          </Button>

          {error && (
            <Typography
              variant="caption"
              color="error.main"
              sx={{ mt: 0.5, display: 'block' }}
            >
              {error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};